import { Routes } from '@angular/router';
import { LayoutComponent } from './layout.component';
import { NoConnectionComponent } from './core/error-page/no-connection.component';
import { PageNotFoundComponent } from './core/error-page/page-not-found.component';
import { ForbiddenComponent } from './core/error-page/forbidden.component';
import { ProfileGuard } from './core/guards/profile.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [ProfileGuard],
    children: [
      {
        path: 'distributor',
        loadChildren: () => import('./distributor/distributor.routes').then(m => m.DISTRIBUTOR_ROUTES)
      },
      {
        path: 'tasks',
        loadChildren: () => import('./tasks/tasks.routes').then(m => m.TASKS_ROUTES)
      },
      {
        path: 'no-connection',
        component: NoConnectionComponent
      },
      {
        path: 'forbidden',
        component: ForbiddenComponent
      },
      { path: '**', component: PageNotFoundComponent }
    ]
  }
];
